// language=GraphQL
export const ALL_BARGAIN_SETTINGS_QUERY = `query Query($withBargainTier: Boolean = false) {
  bargainSettings: allTravelBargainSettings {
    id
    active
    untilDaysBeforeStart
    bargainTier @include(if: $withBargainTier) {
      id
      fromPrice
      discount
    }
  }
}`

// language=GraphQL
export const SINGLE_BARGAIN_SETTINGS_QUERY = `query Query($id: ID!, $withBargainTier: Boolean = false) {
  bargainSettings: travelBargainSettings(id: $id) {
    id
    active
    untilDaysBeforeStart
    bargainTier @include(if: $withBargainTier) {
      id
      fromPrice
      discount
    }
  }
}`

// language=GraphQL
export const CREATE_BARGAIN_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelBargainSettingsInput, $withBargainTier: Boolean = false) {
    bargainSettings: createTravelBargainSettings(input: $input) {
      id
      active
      untilDaysBeforeStart
      bargainTier @include(if: $withBargainTier) {
        id
        fromPrice
        discount
      }
    }
  }`

// language=GraphQL
export const UPDATE_BARGAIN_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelBargainSettingsInput, $withBargainTier: Boolean = false) {
    bargainSettings: updateTravelBargainSettings(input: $input) {
      id
      active
      untilDaysBeforeStart
      bargainTier @include(if: $withBargainTier) {
        id
        fromPrice
        discount
      }
    }
  }`

// language=GraphQL
export const DELETE_BARGAIN_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelBargainSettingsInput) {
    deleteTravelBargainSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BARGAIN_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelBargainSettingsInput) {
    forceDeleteTravelBargainSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const BARGAIN_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelBargainSettingsDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
